(() => {
  const init = () => {
    const videos = document.querySelectorAll('[data-customsirge-lazy-video]');
    if (!videos.length || !('IntersectionObserver' in window)) {
      videos.forEach((v) => {
        v.preload = 'auto';
        v.play().catch(() => {});
      });
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.intersectionRatio >= 0.6) {
            if (video.preload === 'none') {
              video.preload = 'auto';
              video.load();
            }
            video.play().catch(() => {});
          } else {
            if (!video.paused) video.pause();
          }
        });
      },
      { threshold: [0, 0.6] }
    );
    videos.forEach((video) => io.observe(video));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
